import { Box, Divider, Skeleton } from "@mui/material"
import { theme } from "../../../styles"

export const SkeletonGeoVelesList = () => {
    return (
        <Box display="flex" flexDirection="column" gap={2}>
            {[...Array(5)].map((_, index) => (
                <Box key={index}>
                    <Box display="flex" alignItems="center">
                        <Skeleton variant="circular" width={40} height={40} />
                        <Box ml={2} width="80%">
                            <Skeleton variant="text" width="100%" height={20} />
                            <Skeleton variant="text" width="60%" height={20} />
                        </Box>
                    </Box>
                    <Divider color={theme.palette.primary.main} />
                </Box>
            ))}
        </Box>
    )
}